<acf>
  return component('fifty-logos', [
    'sub_fields' => [
      fragment_field(),
      content_field('left_content'),
      repeater_field('logos', [
        'sub_fields' => [
          image_field('logo'),
          url_field()
        ]
      ])
    ]
  ]);
</acf>

<php>
  return function ($content) {
    $content['field_FiftyLogos_left_content'] = wpautop($content['field_FiftyLogos_left_content']);

    $ids = array_column($content['field_FiftyLogos_logos'], 'field_FiftyLogos_logo');
    $content['logos'] = array_map('wp_get_attachment_url', $ids);

    $content['urls'] = array_column($content['field_FiftyLogos_logos'], 'field_FiftyLogos_url');

    unset($content['field_FiftyLogos_logos']);

    return $content;
  };
</php>

<script>
  export default {
    props: ['content']
  }
</script>

<template>
  <section class="section"  :id="content.field_FiftyLogos_fragment_id">
    <div class="container">
      <div class="columns">
        <div class="column is-half">
          <div class="content" v-html="content.field_FiftyLogos_left_content">
          </div>
        </div>
        <div class="column is-half">
          <div class="gallery">
            <a v-for="(logo, i) in content.logos" :key=i :href="content.urls[i]">
              <figure class="image is-128x128">
                <img :src="logo" />
              </figure>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import "../sass/variables";

  .section {
    padding: 0.75em 0;
  }

  .column {
    padding: 1.5rem
  }

  .content /deep/ h2 {
    color: white;
  }

  .content {
    padding-top: 65px;
    max-width: 532px;
    padding-bottom: 65px;
  }

  .content p {
    margin-bottom: 2em;
  }

  .column:first-child {
    background: $blue;
    color: white;
  }

  .column:last-child {
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .gallery figure {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .gallery {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(auto-fill, minmax(128px, 1fr));
    grid-gap: 1rem;
  }

  @include desktop {
    .section {
      background: linear-gradient(90deg, $blue 50%, white 50%);
    }
  }

</style>



// WEBPACK FOOTER //
// components/FiftyLogos.vue